import axios from './index'
// 会员类型查询列表
export const getMemberType = params => {
    return axios.post(`api/8300/memberType/getMemberType`, params)
}

// 新增订单
export const newOrder = params => {
    return axios.post(`api/8240/orders/insertOrders`,params)
}
//分页查询我的订单
export const orderQueryMy = params => {
    return axios.post(`api/8240/orders/selectMyOrdersPage`,params)
}
// 修改订单
export const orderUpdate = params => {
    return axios.post(`api/8240/orders/updateOrders`,params)
}

//支付宝支付接口
export const alipay = params => {
    return axios.post(`api/8100/aliPay/aliHtmlPayCreate`,params)
}

//微信宝支付接口
export const weiChatPay = params => {
    return axios.post(`api/8100/wxPay/wxHtmlPayCreate`,params)
}

// 查询订单支付状态
export const orderStatus = params => {
    return axios.post(`api/8240/orders/selectOrdersDdzt`,params)
}

// 查询用户会员信息
export const queryVipInformation = params => {
    return axios.post(`api/8210/user/selectUserMember`, params)
}

